import React from 'react';
import { FiClock, FiMapPin, FiFacebook } from 'react-icons/fi';

export default function TopBar() {
  return (
    <div className="top-bar">
      <div className="site-container top-bar__inner">
        <div className="top-bar__details">
          <div>
            <FiClock />
            <span>Pon-Pt: 9:00-15:30 | Sob: 9:00-14:00</span>
          </div>
          <div>
            <FiMapPin />
            <span>ul. Brzegowa 151, Dzierżoniów</span>
          </div>
        </div>
        <div className="top-bar__social">
          <FiFacebook />
          <a href="https://www.facebook.com/schroniskoazylddz" target="_blank" rel="noopener noreferrer">
            Facebook
          </a>
        </div>
      </div>
    </div>
  );
}
